import React from "react"

import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./newsletter-section-title.module.scss"
import DarkColor from "../../../helpers/dark-color"

const NewsletterSectionTitle = ({ section, styling }) => (
  <div
    className={`${styles.wrapper} ${styling ? styles[`wrapper__${styling}`] : ""}`}
  >
    {styling === "special_edition" ? (
      <>
        <div className={`${styles.decoration} ${styles.decoration__cobalt}`} />
        <div
          className={`${styles.decoration} ${DarkColor(section.color) ? styles.decoration__emerald : styles.decoration__sky}`}
        />
        <div
          className={`${styles.decoration} ${DarkColor(section.color) ? styles.decoration__chartruse : styles.decoration__bloodorange}`}
        />
      </>
    ) : (
      ""
    )}
    <div
      className={`${styles.title} ${DarkColor(section.color) ? styles.title__dark : ""} ${styling ? styles[`title__${styling}`] : ""} ${styles[`title__${section.color?.replaceAll("-", "")}`]}`}
    >
      {styling === "lifestyle" ? (
        <>
          <div className={styles.icon}>
            {section.icon ? (
              <Image {...section.icon?.image} width={60} height={60} alt="" />
            ) : (
              ""
            )}
          </div>
          <div className={styles.titleInner}>{section.title}</div>
          <div className={styles.icon}>
            {section.icon ? (
              <Image {...section.icon?.image} width={60} height={60} alt="" />
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        section.title
      )}
    </div>
  </div>
)

export default NewsletterSectionTitle

NewsletterSectionTitle.propTypes = {
  section: PropTypes.object.isRequired,
  styling: PropTypes.string,
}

NewsletterSectionTitle.defaultProps = {
  styling: "",
}
